<div
  class="suggestion-item"
  [class.active]="isActive"
  (click)="onSuggestionClick()"
  role="option"
  [attr.aria-selected]="isActive"
  [attr.aria-label]="getAriaLabel()">
  <!-- Suggestion icon -->
  <mat-icon class="suggestion-icon">
    {{ getSuggestionIcon(suggestion.type) }}
  </mat-icon>

  <!-- Suggestion content -->
  <div class="suggestion-content">
    <!-- Main text -->
    <div class="suggestion-text">{{ suggestion.text }}</div>

    <!-- Metadata: type, confidence, history -->
    <div class="suggestion-metadata">
      <span class="suggestion-type-label">
        {{ getSuggestionLabel(suggestion.type) }}
      </span>

      <!-- Confidence badge -->
      <!--      <span-->
      <!--        *ngIf="suggestion.confidence > 0"-->
      <!--        class="confidence-badge"-->
      <!--        [ngClass]="{-->
      <!--          'high-confidence': suggestion.confidence > 80,-->
      <!--          'medium-confidence': suggestion.confidence > 60,-->
      <!--          'low-confidence': suggestion.confidence <= 60-->
      <!--        }">-->
      <!--        {{ suggestion.confidence }}%-->
      <!--      </span>-->

      <!-- History indicator -->
      <span *ngIf="suggestion.lastUsed" class="history-indicator">
        <mat-icon class="history-icon">history</mat-icon>
        Used {{ suggestion.usageCount || 1 }} time(s)
      </span>
    </div>
  </div>

  <!-- Action arrow -->
  <mat-icon class="suggestion-action-icon">keyboard_arrow_right</mat-icon>
</div>
